module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsChristmas.1973871.webp";